// extracted by mini-css-extract-plugin
module.exports = {"providerAvatar":"providerAvatar__1YXDG","providerValue":"providerValue__32iqY"};